
import React from 'react'
import DetailContainer from '../MainPage/common/DetailContainer'
import { images } from '../common/images';

function TemperatureDetailContainer({ selectedDeviceSelectedDayData, live = true }) {
    let totalTemperatureLogs = selectedDeviceSelectedDayData.length>0 && selectedDeviceSelectedDayData?.reduce((acc, curr) => [...acc, ...(curr?.temperatureLogs ?? [])], []).filter(e=>e.t>=-50).sort((a, b) => a.ts - b.ts)
    let latestTemperature = totalTemperatureLogs.length>0 ? totalTemperatureLogs.slice(-1)[0] : null

    return (
        <DetailContainer
            name={"Temperature"}
            value={`${latestTemperature?.t.toFixed(2) || 0}°C`}
            time={latestTemperature?.ts || 0}
            hasLog={latestTemperature !== null}
            reading
            live={live}
            showDay={selectedDeviceSelectedDayData.length>1 ? true : false}
            color={"#FDECEC"}
            borderColor={"#EF4444"}
            image={images.temperature}
        />
    )
}

export default TemperatureDetailContainer